// import env from '@/env'
// import config from '@/config'
// export default async function () {
//   const storageType = env.storageType || config.jwtConfig.storageType || 'sessionStorage'
//   const tokenText = env.token || config.jwtConfig.token || 'token'
//   window[storageType].removeItem(tokenText)
//   try {
//     return new Promise((resolve, reject) => {
//       resolve({})
//     })
//   } catch (error) {
//     return Promise.reject(error)
//   }
// }
import qs from 'qs'
import { toParams } from './to-params'
export default function () {
  const search = toParams()
  location.replace(
    `auth.html?${qs.stringify({
      channelId: search.channelId
    })}`
  )
}
